import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton, TtIcon } from '@23/react'

import { useLiveDataQuery } from '../../../../../global/blocs/useLiveData'
import { disableFocusMode } from '../../../../blocs/useFocusMode'
import { useOpenFocusConfigurator } from '../../../FocusConfigurator/FocusConfigurator'

import './FocusHeader.scss'

const FocusHeader = () => {
  const { data: liveData } = useLiveDataQuery()
  const openFocusConfigurator = useOpenFocusConfigurator()

  return (
    <div className="focus-header">
      <div className="focus-header-title">{liveData?.name}</div>
      <TtButton
        className="focus-mode-configure"
        color="secondary"
        size="small"
        onClick={openFocusConfigurator}
      >
        <TtIcon slot="prefix" library="one" name="settings" />
        <FormattedMessage defaultMessage="Configure" />
      </TtButton>
      <TtButton
        className="focus-mode-stop"
        color="secondary"
        size="small"
        onClick={disableFocusMode}
      >
        <FormattedMessage defaultMessage="Close" />
        <TtIcon slot="suffix" library="one" name="close" />
      </TtButton>
    </div>
  )
}

export { FocusHeader }
